import { tokens } from '@env0/ui-theme';

/** `scale` is the base ladder the others alias; prefer the semantic names. */
export const sharedPrimitives = {
  scale: tokens.spacing.scale,
  spacing: tokens.spacing.spacing,
  padding: tokens.spacing.padding,
  radius: tokens.spacing.radius,
  borderWidth: tokens.spacing.borderWidth,
  zIndex: tokens.zIndex,
  shadows: tokens.shadows
} as const;

export type DesignPrimitives = typeof sharedPrimitives;

/**
 * antd 5.6.4's own ladder, which the app renders on today. Figma's numbers are MUI's (md 900) and its
 * descriptions mark them PROVISIONAL, so these hold until design decides
 * (APO-455 D4) — adopting md 900 moves the mobile boundary for 45 `isMobile` reads, a behaviour
 * change rather than a repaint.
 */
export const ANTD_BREAKPOINTS = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px'
} as const;

export type Breakpoints = typeof ANTD_BREAKPOINTS;

export type LayoutDimensions = Record<keyof typeof tokens.layout, string>;
